import React from "react";
import { Card, CardActionArea, CardContent, SxProps, Theme } from "@mui/material";

interface CardContainerProps {
    isSelected: boolean;
    children: React.ReactNode;
    onClick: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    cardStyles?: SxProps<Theme>;
    cardContentStyles?: SxProps<Theme>;
}

const CardContainer: React.FC<CardContainerProps> = ({
    isSelected,
    onClick,
    onMouseEnter,
    onMouseLeave,
    children,
    cardStyles,
    cardContentStyles
}) => {
    return (
        <Card
            sx={cardStyles ?
                cardStyles // Override with props styles completely
                : 
                {
                    backgroundColor: isSelected ? "rgba(99, 164, 255, 0.3)" : "inherit",
                }
            }
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <CardActionArea onClick={onClick}>
                <CardContent sx={
                    cardContentStyles ?
                        cardContentStyles // Override with props styles completely
                        : { padding: 0.5 }}
                >
                    {children}
                </CardContent>

            </CardActionArea>
        </Card>
    );
};

export default CardContainer;